var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';


import { DraggableItem, DropZone } from "../../Layouts/DragAndDrop";
import { GrabDoubleIcon } from "../../CustomIcons";
















// eslint-disable-next-line comma-spacing
const GrabIcon = ({ dndContext, row, previewRef, item }) => {
  const grabIconColor =
  row.getCanExpand() || row.depth > 0 ? 'rgb(199 210 254)' : 'rgb(224 231 255)';
  return /*#__PURE__*/(
    _jsx(DraggableItem, {

      item: item,
      index: row.index,
      context: dndContext,
      wrapperType: "div",
      className: "border-0",
      container: row.parentId ? `group_${row.parentId}` : 'root',
      iconHandle: true,
      previewRef: previewRef }, `grab_${item.dndId}`, /*#__PURE__*/

    _jsx(GrabDoubleIcon, { className: "w-2", color: `${grabIconColor}` })
    ));

};

const RowWrapper =

({ children, dndContext, row, draggableRow, className, innerRef }) => {
  if (!draggableRow || !dndContext) {
    return /*#__PURE__*/(
      _jsx("tr", { className: className }, `row_${row.id}`,
      children
      ));

  }
  const notParent = !row.parentId && row.getLeafRows().length === 0;
  const parentItem = dndContext.activeItems.find((item) => item.dndId === row.parentId);
  return /*#__PURE__*/(
    _jsx(DropZone, {
      type: dndContext.type,
      className: className,
      activeClassName: "border-t-4 border-primary-300",
      context: dndContext,
      name: notParent ? `row_${row.id}` : `group_${row.id}`,

      wrapperType: "tr",
      parent: row.parentId ? parentItem : undefined,
      innerRef: innerRef }, notParent ? `row_${row.id}` : `group_${row.id}`,

    children
    ));

};

export { RowWrapper, GrabIcon };